import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { DropDownContext } from './custom-dropdown';
import DropDownOption from './dropdown-option';
import DropDownOptionWithToggle from './dropdown-option-with-toggle';
import { DropDownType } from './dropdown-props';

const DropdownMenu = () => {
  const {
    isOpen,
    options,
    type,
    isMultiselect,
    toggleMenu,
    setSelectedOptions,
    selectedOptions,
    onSelection,
    isDraggable = false,
    menuWidth = 175
  } = useContext(DropDownContext);
  const [position, setPosition] = useState('left');
  const dropdownRef = useRef(null);

  const calculatePosition = () => {
    const dropdownRect = dropdownRef.current.getBoundingClientRect();
    const spaceRight = window.innerWidth - dropdownRect.right;

    if (spaceRight <= menuWidth) {
      return 'right';
    } else {
      return 'left';
    }
  };

  useLayoutEffect(() => {
    if (!!dropdownRef.current) {
      const position = calculatePosition();
      setPosition(position);
    }
  }, [dropdownRef]);

  const onOptionClick = ({ e, option }) => {
    e.stopPropagation();
    e.preventDefault();
    let updatedOptions;
    if (isMultiselect) {
      // it will help to keep the menu open
      if (isPresent(option)) {
        updatedOptions = filteredArray(option);
      } else {
        updatedOptions = [...selectedOptions, option];
      }
    } else {
      updatedOptions = option;
      toggleMenu();
    }
    setSelectedOptions(updatedOptions);
    if (!!onSelection) onSelection(updatedOptions);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(options);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Update your state with the new order
    // Assuming options is part of your component's state
    // setOptions(items); // Uncomment and use this if you maintain options in state
  };

  const isPresent = (option) =>
    isMultiselect
      ? !!selectedOptions && selectedOptions.some((obj) => obj.value === option.value)
      : option.value === selectedOptions.value;

  const filteredArray = (option) =>
    isMultiselect
      ? !!selectedOptions && selectedOptions.filter((obj) => obj.value !== option.value)
      : option.value !== selectedOptions.value;

  return (
    <div ref={dropdownRef}>
      <DragDropContext
        onDragEnd={(result) => {
          onDragEnd(result);
        }}
        onDragUpdate={(result) => onDragEnd(result)}
      >
        <Droppable droppableId="dropdownDroppable">
          {(provided) => (
            <div className={`menu ${position}`} ref={provided.innerRef}>
              {isOpen && (
                <div {...provided.droppableProps}>
                  {options &&
                    options.map((option, index) => (
                      <Draggable
                        key={option.value}
                        style={{ cursor: isDraggable ? 'grab' : 'pointer' }}
                        draggableId={isDraggable ? option.value : 1}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            {type === DropDownType.DEFAULT ? (
                              <DropDownOption
                                edgeDiv={{ index, length: options.length }}
                                option={option}

                                onOptionClick={onOptionClick}
                                isPresent={isPresent}
                              />
                            ) : (
                              <DropDownOptionWithToggle
                                option={option}
                                onOptionClick={onOptionClick}
                                isPresent={isPresent}
                              />
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default DropdownMenu;
